// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".styles-module__profilePageAlert___rQ9Xo {\n  margin-bottom: 1rem;\n}\n", "",{"version":3,"sources":["webpack://screens/business-profile-page/styles.module.less"],"names":[],"mappings":"AAAA;EACE,mBAAA;AACF","sourcesContent":[".profilePageAlert {\n  margin-bottom: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"profilePageAlert": "styles-module__profilePageAlert___rQ9Xo"
};
export default ___CSS_LOADER_EXPORT___;
